import { render, staticRenderFns } from "./item.vue?vue&type=template&id=02bfc2b0"
import script from "./item.vue?vue&type=script&lang=js"
export * from "./item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02bfc2b0')) {
      api.createRecord('02bfc2b0', component.options)
    } else {
      api.reload('02bfc2b0', component.options)
    }
    module.hot.accept("./item.vue?vue&type=template&id=02bfc2b0", function () {
      api.rerender('02bfc2b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/components/basic/carousel/src/item.vue"
export default component.exports